import React, { useRef, useState, useEffect, forwardRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styled, useTheme } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import Divider from "@mui/material/Divider";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { setOrganization } from "../../store/organziationSlice";
import { setPermissions } from "../../store/permissionsSlice";
import personService from "../../api/person";
import { ContainsFileExtension } from "../../utils/systemInfo";
import OrganizationService from "../../api/organization";
import { config } from "../../config";

const StyleSpan = styled((props) => <span {...props} />)(({ theme }) => ({
  color: theme.palette.custom.text,

}));
const StyledMenu = styled((props) => <Menu {...props} />)(({ theme }) => ({
  "& .MuiPaper-root": {
    backgroundColor: theme.palette.custom.backgroundColor,
    color: theme.palette.custom.text,
  },
}));
function OrganizationsMenu(props) {
  const dispatch = useDispatch();
  const searchInputRef = useRef(null);
  const { t } = useTranslation();
  const theme = useTheme();
  const organziation = useSelector(({ organziation }) => organziation);
  const user = useSelector(({ user }) => user);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [organizationsList, setOrganizationsList] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [propsOrganization, setPropsOrganization] = useState(null);
  const [allOrganizations, setAllOrganizations] = useState([]);

  useEffect(() => {
    if (user?.organizations) {
      setOrganizationsList(
        user.organizations.filter(
          (x) =>
            x.app_profile_info.full_name === window.env.REACT_APP_API_APP_NAME
        )
      );
    }
  }, [user]);
  useEffect(() => {
    if (props.onChange && !props.userListOnly) {
      if (allOrganizations.length) {
        setPropsOrganization(
          allOrganizations.find((org) => org.uid === props.operationId)
        );
      } else {
        OrganizationService.GetOperationProfile({
          operation_profile_id: "",
          operation_full_name: "",
          apiKey: config.url.api_key_current,
        })
          .then((json) => {
            setAllOrganizations(json?.operation);
            setPropsOrganization(
              json?.operation.find((org) => org.uid === props.operationId)
            );
          })
          .catch((error) => {
            if (process.env.NODE_ENV === "development") console.error(error);
          });
      }
    } else if (props.userListOnly) {
      setPropsOrganization(
        user.organizations.find((org) => org?.operation_profile_info?.uid?.toString() === props.operationId?.toString())?.operation_profile_info
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleGetIcon = (orgObj) => {
    let imageurl = "logo-icon.png";
    if (orgObj?.operation_image_list?.length || orgObj?.image?.length) {
      const imagesArray = orgObj.operation_image_list || orgObj?.image;
      for (let i in imagesArray) {
        if (
          imagesArray[i].image_type === "small_logo" &&
          imagesArray[i].status === "active"
        ) {
          if (ContainsFileExtension(imagesArray[i].public_url)) {
            imageurl = imagesArray[i].public_url;
            break;
          }
        }
      }
      //   for (let index = 0; index < orgObj.operation_image_list.length; index++) {
      //     if (
      //       orgObj.operation_image_list[index].image_type === "small_logo" &&
      //       orgObj.operation_image_list[index].public_url?.includes(".png")
      //     )
      //       imageurl = orgObj.operation_image_list[index].public_url;
      //   }
    }
    return imageurl;
  };
  const handleChooseOrganization = (userOrgObj) => {
    if (props.onChange) {
      props.onChange(userOrgObj.operation_profile_info.uid, userOrgObj.operation_profile_info);
      handleCloseUserMenu();
    } else {
      const operationProfileInfo = userOrgObj.operation_profile_info;
      localStorage.setItem(
        "defaultOrganization",
        JSON.stringify(operationProfileInfo)
      );
      localStorage.setItem(
        "apiKey",
        operationProfileInfo?.api_key_list?.[0]?.key
      );
      dispatch(setOrganization(operationProfileInfo));
      window.location.reload();
      const operationPersonProfileInfo =
        userOrgObj.operation_person_profile_link_info;
      const apiKey = operationProfileInfo.api_key_list[0].key;
      const userType = operationPersonProfileInfo.user_type_uid;
      personService
        .getUserTypePermissions({ apiKey, userType })
        .then((json) => {
          const UserPermissions = [];
          if (
            json &&
            json.app_user_type_permission_link &&
            json.app_user_type_permission_link.length > 0
          ) {
            for (let i in json.app_user_type_permission_link)
              if (userType === json.app_user_type_permission_link[i].user_type_uid) {
                UserPermissions.push(
                  json.app_user_type_permission_link[i].permission_secondary
                    .permission_secondary_uid
                );
              }
            localStorage.setItem(
              "permissions",
              JSON.stringify(UserPermissions)
            );
            dispatch(setPermissions(UserPermissions));
          }
        })
        .catch((errorr) => {
          if (process.env.NODE_ENV === "development")
            console.log("getUserTypePermissionserrorr", errorr);
        });
    }
  };
  function handleSearch(ev) {
    const newSearchText = ev.target.value;

    setSearchText(newSearchText);

    if (newSearchText.length && user?.organizations) {
      setOrganizationsList(
        user.organizations.filter(
          (item) =>
            item.app_profile_info.full_name ===
            window.env.REACT_APP_API_APP_NAME &&
            item.operation_profile_info.full_name
              .toLowerCase()
              ?.includes(newSearchText.toLowerCase())
        )
      );
      return;
    } else if (user?.organizations) {
      setOrganizationsList(
        user.organizations.filter(
          (x) =>
            x.app_profile_info.full_name === window.env.REACT_APP_API_APP_NAME
        )
      );
    }
  }
  function compare(a, b) {
    // Use toUpperCase() to ignore character casing
    const bandA = a.operation_profile_info.full_name.toUpperCase();
    const bandB = b.operation_profile_info.full_name.toUpperCase();

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  const itemsToRender = (allOrganizations?.length
    ? allOrganizations.map(org => ({ operation_profile_info: org }))
    : organizationsList
  ) || [];
  return (
    <>
      <Tooltip title={props.tooltip || t("Open settings")}>
        <Button
          sx={{
            border: props.onChange ? 1 : 0,
            borderColor: theme.palette.custom.borderColor,
            borderRadius: "11px",
          }}
          variant="text"
          onClick={handleOpenUserMenu}
          startIcon={
            <Avatar
              alt="Remy Sharp"
              src={handleGetIcon(propsOrganization || organziation)}
            />
          }
        >
          <StyleSpan sx={{
            [theme.breakpoints.down("md")]: {
              display: !propsOrganization ? "none" : "block",
            },
          }}>
            {(propsOrganization || organziation)?.short_name?.toUpperCase() || ""}
          </StyleSpan>
        </Button>
      </Tooltip>
      <StyledMenu
        id="menu-appbar"
        anchorEl={anchorElUser}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
        keepMounted
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        TransitionProps={{
          onEntered: () => {
            searchInputRef.current.focus();
          },
        }}
      >
        {/* <Box
                    component="form"
                    sx={{
                        '& > :not(style)': { m: 1, width: '25ch' },
                    }}
                    noValidate
                    autoComplete="off"
                >
                    <TextField
                        value={searchText}
                        onChange={handleSearch}
                        inputRef={searchInputRef}
                        id="outlined-uncontrolled"
                       
                        defaultValue="foo"
                        sx={{ ml: '2%', width: '95%', borderRadius: '11px', backgroundColor: theme.palette.custom.light }}

                    />
                </Box> */}
        {/* <Input
                    //  inputRef={searchInputRef}
                    //value={searchText}
                    // onChange={handleSearch}
                    placeholder="Search for an app or page"
                    inputProps={{
                        'aria-label': 'Search',
                    }}
                    sx={{ ml: '2%', width: '95%', borderRadius: '11px', backgroundColor: theme.palette.custom.light }}
                    disableUnderline
                /> */}
        <TextField
          inputRef={searchInputRef}
          value={searchText}
          onChange={handleSearch}
          margin="normal"
          fullWidth
          id="search"
          label={t("Search")}
          name="search"
          autoFocus
          onKeyDown={(e) => {
            e.stopPropagation();
          }}
          sx={[
            { ml: "2%" },
            { width: "95%" },
            { borderRadius: "11px" },
            { backgroundColor: theme.palette.custom.inputBackgroundColor },
            {
              "&:active": {
                borderColor: theme.palette.custom.borderColor,
                color: theme.palette.custom.text,
              },
            },
          ]}
        />
        <Divider
          sx={{ my: "10px", backgroundColor: theme.palette.custom.light }}
        />
        {itemsToRender?.sort(compare).map((setting) => (
          <MenuItem
            key={setting.operation_profile_info?.uid}
            onClick={() => handleChooseOrganization(setting)}
            sx={{
              backgroundColor:
                (propsOrganization || organziation)?.uid === setting.operation_profile_info?.uid &&
                theme.palette.custom.borderColor,
            }}
          >
            <Avatar
              sx={{ mr: 1 }}
              alt="Remy Sharp"
              src={handleGetIcon(setting.operation_profile_info)}
            />
            <Typography
              sx={{ color: theme.palette.custom.text }}
              textAlign="center"
            >
              {setting.operation_profile_info
                ? setting.operation_profile_info.full_name
                : ""}
            </Typography>
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  );
}
OrganizationsMenu.propTypes = {
  operationId: PropTypes.number,
  onChange: PropTypes.func,
  tooltip: PropTypes.string,
  userListOnly: PropTypes.bool,
};

export default forwardRef(OrganizationsMenu, { forwardRef: true });
